import { FC, ReactNode } from 'react';

import classNames from 'classnames';

import dataAttributes from '../../../../utils/attributes/attributes';
import { Box } from '../../../box/components/Box/Box';
import { Icon } from '../../../icon/components/Icon/Icon';
import { Image } from '../../../image/components/Image/Image';
import { Typography } from '../../../typography/components/Typography/Typography';

interface Props {
   image?: string;
   alt?: string;
   title?: string;
   ratio?: '1:1' | '5:4';
   trailingIcon?: string;
   attributes?: Record<string, string>;
   onClick?: () => void;
   children?: ReactNode;
}

export const Tile: FC<Props> = ({ image, alt = '', title = '', ratio = '1:1', trailingIcon, attributes = {}, onClick, children }) => (
   <div
      data-testid="tile"
      className={classNames('rounded-component-data-display-tile-container-border-radius relative w-full overflow-hidden bg-cover bg-center', ratio === '1:1' && 'aspect-square', ratio === '5:4' && 'aspect-[5/4]', onClick ? 'cursor-pointer' : 'pointer-events-none')}
      onClick={onClick}
      role="presentation"
      {...dataAttributes(attributes)}
   >
      {image && (
         <Box position="absolute" top="0" left="0" height="100%" width="100%">
            <Image src={image} alt={alt} title={title} width="100%" />
         </Box>
      )}
      <div
         className={classNames(
            'px-component-data-display-tile-caption-container-spacing-padding-x-no-icon py-component-data-display-tile-caption-container-spacing-padding-y bg-component-data-display-tile-caption-container-color-background-gradient-scrimmed text-component-data-display-tile-caption-container-color-text-on-scrimmed absolute inset-0 flex items-end justify-between',
            {
               'pr-component-data-display-tile-caption-container-spacing-padding-x-icon': trailingIcon
            }
         )}
      >
         <Typography variant="body-highlight" color="inherit">
            {children}
         </Typography>
         {trailingIcon && (
            <div data-testid="tile-trailing-icon">
               <Icon icon={trailingIcon} color="inherit" />
            </div>
         )}
      </div>
   </div>
);
